import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../utils/apiClient';
import { useAuth } from '../context/AuthContext';
import { BRAND_NAME, BRAND_SHORT } from '../constants/brand';
import logoFallback from '../assets/koc-logo.svg';
import '../styles/Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    identifier: '',
    password: '',
  });
  const [error, setError] = useState(null);
  const [logoutMessage, setLogoutMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [logoSrc, setLogoSrc] = useState(`${process.env.PUBLIC_URL || ''}/koc_logo_r4.png`);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const reason = localStorage.getItem('auth_logout_reason');
    if (reason) {
      setLogoutMessage(reason);
      localStorage.removeItem('auth_logout_reason');
    }
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (error) setError(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.identifier || !formData.password) {
      setError('Lütfen tüm alanları doldurun.');
      return;
    }

    try {
      setLoading(true);
      const response = await apiClient.post('/auth/login', {
        identifier: formData.identifier.trim(),
        password: formData.password,
      });

      login(response.data.token, response.data.user);
      if (response.data?.user?.must_change_password) {
        navigate('/first-password');
      } else {
        navigate('/');
      }
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Giriş başarısız oldu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-brand">
          <div className="brand-content">
            <img
              src={logoSrc}
              alt="Koç İnşaat logo"
              className="brand-logo-image"
              onError={() => setLogoSrc((current) => (current === logoFallback ? current : logoFallback))}
            />
            <h1>{BRAND_SHORT}</h1>
            <p>{BRAND_NAME}</p>
            <div className="brand-features">
              <div className="feature"><span>01</span><span>Proje ve Takvim Kontrolü</span></div>
              <div className="feature"><span>02</span><span>Puantaj ve Onay Yönetimi</span></div>
              <div className="feature"><span>03</span><span>Günlük Rapor ve Doküman Takibi</span></div>
              <div className="feature"><span>04</span><span>Ekip, Kaynak ve Görev Koordinasyonu</span></div>
              <div className="feature"><span>05</span><span>Muhasebe Paneli ve Mizan Takibi</span></div>
              <div className="feature"><span>06</span><span>Akıllı Uyarılar ve Mobil Bildirimler</span></div>
            </div>
          </div>
        </div>

        <div className="auth-form-section">
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-header">
              <h2>Hesaba Giriş</h2>
              <p>{BRAND_NAME}</p>
            </div>

            {logoutMessage && (
              <div className="alert alert-info">
                <span className="alert-icon">i</span>
                <span>{logoutMessage}</span>
              </div>
            )}

            {error && (
              <div className="alert alert-danger">
                <span className="alert-icon">!</span>
                <span>{error}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="identifier">E-posta veya Kullanıcı Adı</label>
              <input
                type="text"
                id="identifier"
                name="identifier"
                value={formData.identifier}
                onChange={handleChange}
                placeholder="e-posta veya kullanıcı adı"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Şifre</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Şifrenizi girin"
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Giriş yapılıyor...
                </>
              ) : (
                'Giriş Yap'
              )}
            </button>

            <div className="form-footer">
              <p>Hesap oluşturma sadece yönetici tarafından yapılır.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
